function getCookieValue(name) {
    var cookieArr = document.cookie.split('; ');
    var selectedCookie = cookieArr.find(function (cookie) {
        var cookieName = cookie.split('=')[0];
        return cookieName === name;
    });
    return selectedCookie ? decodeURIComponent(selectedCookie.split('=')[1] || '') : null;
}
export var getToken = function (tokenKey) {
    var keyStructure = tokenKey.split('.');
    if (keyStructure.length === 2 &&
        (keyStructure[0].toLocaleLowerCase() === 'localstorage' ||
            keyStructure[0].toLocaleLowerCase() === 'cookie')) {
        var key = keyStructure[1];
        if (keyStructure[0].toLocaleLowerCase() === 'localstorage') {
            // Fetch value from localStorage
            var value = localStorage.getItem(key);
            try {
                // Attempt to parse the data
                return JSON.parse(value !== null && value !== void 0 ? value : '');
            }
            catch (e) {
                // If parsing fails, return the original data
                return value;
            }
        }
        else if (keyStructure[0].toLocaleLowerCase() === 'cookie') {
            // Fetch value from cookie
            return getCookieValue(key);
        }
    }
    // Return null if conditions are not met
    return null;
};
export var getTokenDetails = function (tokenKey) {
    var keyStructure = tokenKey.split('.');
    if (keyStructure.length === 2 &&
        (keyStructure[0].toLocaleLowerCase() === 'localstorage' ||
            keyStructure[0].toLocaleLowerCase() === 'cookie')) {
        return {
            type: keyStructure[0].toLocaleLowerCase(),
            key: keyStructure[1],
        };
    }
    return null;
};
